// imports
import { atom } from 'jotai'
import CompanionState from "@/lib/types/atoms/companionState";

// lib files
import { SearchResults } from '@/lib/types/search/results'

const searchResultsAtom = atom<SearchResults | null>(null)
const searchResultsStatus = atom<CompanionState>(CompanionState.NotLoaded)

export { searchResultsAtom, searchResultsStatus }
